import { Suspense, createRef } from 'react';
import { Route, Switch } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import muiTheme from './style/muiTheme';

import PrivateRoute from './PrivateRoute';

import { AuthProvider } from './contexts/AuthContext';

import './App.css';
import Home from './views/Home';
import Login from './views/Login';
import MasterHome from './views/MasterHome';
import StudentHome from './views/StudentHome';
import GameSettingsView from './views/GameSettingsView';
import GameView from './views/GameView';
import RegisterView from './views/Register';
import RegistrationConfirmation from './views/RegistrationConfirmation';
import HighscoresView from './views/Highscores';

/*
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

const { enqueueSnackbar } = useSnackbar();
const { t } = useTranslation();

enqueueSnackbar(t('error.loadHighscores'), {
                    variant: 'error',
                });

variant = default | success | error | warning | info
*/
function App() {
    const notistackRef = createRef();
    const onClickDismiss = (key) => () => {
        notistackRef.current.closeSnackbar(key);
    };
    return (
        <Suspense fallback="...is loading">
            <AuthProvider>
                <SnackbarProvider
                    ref={notistackRef}
                    action={(key) => (
                        <IconButton onClick={onClickDismiss(key)}>
                            <CloseIcon />
                        </IconButton>
                    )}
                    maxSnack={6}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <ThemeProvider theme={muiTheme}>
                        <Switch>
                            <Route path="/login">
                                <Login />
                            </Route>
                            <PrivateRoute path="/master/gamesettings">
                                <GameSettingsView />
                            </PrivateRoute>
                            <Route path="/master">
                                <MasterHome />
                            </Route>
                            <PrivateRoute path="/student/game">
                                <GameView />
                            </PrivateRoute>
                            <Route path="/student/register">
                                <RegisterView />
                            </Route>
                            <Route path="/student/confirm-registration">
                                <RegistrationConfirmation />
                            </Route>
                            <Route path="/student">
                                <StudentHome />
                            </Route>

                            <Route path="/highscores">
                                <HighscoresView />
                            </Route>
                            <Route exact path="/">
                                <Home />
                            </Route>
                        </Switch>
                    </ThemeProvider>
                </SnackbarProvider>
            </AuthProvider>
        </Suspense>
    );
}

export default App;
